<template>
    <div class="">
        <div class="crumbsNav stockAndCloudBox no_print clearfix">
            <div :class="['navSon',tab==1?'navSonChecked':'']" @click="changeTab(1)">
                选择库存
            </div>
            <div v-if="module.indexOf(',cloud-inventory-spots,')!=-1" :class="['navSon',tab==2?'navSonChecked':'']" @click="changeTab(2)">
                云链现货
            </div>
        </div>
        <select-stock ref="stockselect" v-show="tab == 1" @cancel="cancel()" @selectData="selectData" @selectAndOut="selectAndOut"></select-stock>
        <cloud-select-product ref="selectcloud"  v-show="tab == 2" @cancel="cancel()" @selectData="selectData" @selectAndOut="selectAndOut"></cloud-select-product>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                module:localStorage.dw_erp_power_code,
                tab : 1
            }
        },
        created(){
        },
        methods:{
            changeTab(tab){
                //this.tab=tab;
                this.$set(this,"tab",tab);
            },
            cancel(){
                this.$emit("cancel")
            },
            selectData(row){
                this.$emit("selectData",row)
            },
            selectAndOut(row){
                this.$emit("selectAndOut",row)
            },
            resetSelect(){
                if(this.$refs['stockselect']){
                    this.$refs['stockselect'].resetSelect();
                }
                if(this.$refs['selectcloud']){
                    this.$refs['selectcloud'].resetSelect();
                }
            }
        },
        watch:{
            tab:function(val){
                if(val == 1){
                    if(this.$refs['selectcloud']){
                        this.$refs['selectcloud'].resetSelect();
                    }
                }else if(val == 2){
                    if(this.$refs['stockselect']){
                        this.$refs['stockselect'].resetSelect();
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .stockAndCloudBox{width: 235px;position: absolute;top: 0;left: 0;right: 0;margin: auto;}
    .navSon:nth-child(2){margin-right:0;}
</style>